import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { store } from "../src/app/store"
import { Provider } from 'react-redux';
import { BrowserRouter } from "react-router-dom"
import { CartSelectorProvider } from './pages/cartSelectorContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <CartSelectorProvider>
            <App />
          </CartSelectorProvider>
        </BrowserRouter>
      </Provider>
  </React.StrictMode>
);

